module.exports = __webpack_public_path__ + "img/fuwu.33cbdbb0.png";